import React from "react";

import { ExclamationCircle } from "../../../../components/icons/svg/outline";

/**
 * Compact full-width banner shown before sending dispatch SMS messages.
 *
 * @param {Object} props
 * @param {number} props.messageCount Number of SMS recipients selected.
 * @param {number} [props.costPerMessage=0.021] Cost per message in dollars (reserved for future copy).
 * @returns {JSX.Element}
 */
export default function SMSCostWarning({
  messageCount,
  costPerMessage = 0.021,
}) {
  // const cost = (messageCount * costPerMessage).toFixed(2);
  const isEmpty = messageCount === 0;
  const toneClass = isEmpty
    ? "border-sky-200 bg-sky-50 text-sky-800"
    : "border-amber-200 bg-amber-50 text-amber-800";

  return (
    <div
      className={`flex w-full items-center justify-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-medium ${toneClass}`}
      role="status"
    >
      <ExclamationCircle className="h-3.5 w-3.5 shrink-0" aria-hidden />
      {isEmpty ? (
        <span>Please select workers to send your message.</span>
      ) : (
        <span>
          This will send <span className="font-semibold">{messageCount}</span>{" "}
          SMS {messageCount === 1 ? "message" : "messages"}
        </span>
      )}
    </div>
  );
}
